import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getCreateDepositAccountPath = () => urlHelper('/deposit-accounts/create');
